import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { Stack } from '@mui/material';
import selectors from 'store/selectors';
import UsersAndTeamsIcon from 'components/Icons/sidebarIcons/usersAndTeamsIcon';
import { LocationIconCnt, PreviewAssigneeListCnt } from './styled';
import LocationIcon from 'components/Icons/locationIcon';
import { useAssigneesList } from 'utils/CustomHooks/useAssigneesList';
import UserAvatar from 'components/AssigneesView/AvatarsList/userAvatar';
import TeamAvatar from 'components/AssigneesView/AvatarsList/teamAvatar';
interface CreateTaskPropTypes {
  assignees?: string[] | null;
  newTask?: any;
}
function PreviewAssigneeList(props: CreateTaskPropTypes) {
  const { assignees } = props;
  const { groupAssigneesByType } = useAssigneesList();
  const authorizedUsers = useSelector(selectors.getAuthorizedUsers);
  const locationsHash = useSelector(selectors.getLocationsHash);
  const selectedUsers = authorizedUsers.filter((user) =>
    assignees?.includes(user.id),
  );
  const allAssignee = assignees && {
    ...groupAssigneesByType(assignees, true),
    people: selectedUsers,
  };
  const hasAssignees =
    allAssignee?.people?.length > 0 || allAssignee?.teams?.length > 0;

  return (
    <PreviewAssigneeListCnt>
      {!hasAssignees ? (
        <Box textAlign={'center'} py={'16px'}>
          <Box className="icon">
            <UsersAndTeamsIcon filled />
          </Box>
          <Typography
            fontSize={'14px'}
            fontWeight={600}
            color="#212121"
            sx={{ marginLeft: '8px' }}
          >
            Please Select Assignee
          </Typography>
        </Box>
      ) : (
        <>
          {allAssignee?.people?.length > 0 && (
            <>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 13,
                  lineHeight: '17.76px',
                  color: '#616161',
                  marginTop: '13px',
                  marginBottom: '8px',
                }}
              >
                People
              </Typography>
              {allAssignee.people.map((item) => (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  style={{ width: '100%' }}
                  gap="10px"
                  className="previewAssigneeItem"
                >
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={'12px'}
                  >
                    <UserAvatar data={item} />
                    <Typography
                      fontSize={'14px'}
                      fontWeight={600}
                      color="#212121"
                    >
                      {item?.firstName} {item?.lastName}
                      {!item?.firstName && !item?.lastName && item?.emailId}
                    </Typography>
                  </Stack>
                  {item?.defaultLocationId && (
                    <LocationIconCnt>
                      <LocationIcon
                        sx={{
                          fontSize: 20,
                          color: '#78909C',
                        }}
                        filled
                      />

                      {locationsHash?.[item?.defaultLocationId]
                        ? locationsHash?.[item?.defaultLocationId]?.name
                        : ''}
                    </LocationIconCnt>
                  )}
                </Stack>
              ))}
            </>
          )}

          {allAssignee?.teams?.length > 0 && (
            <>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 13,
                  lineHeight: '17.76px',
                  color: '#616161',
                  marginTop: '13px',
                  marginBottom: '8px',
                }}
              >
                Team
              </Typography>
              {allAssignee.teams.map((item) => (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  style={{ width: '100%' }}
                  gap="10px"
                  className="previewAssigneeItem"
                >
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={'12px'}
                  >
                    <TeamAvatar data={item} />
                    <Typography
                      fontSize={'14px'}
                      fontWeight={600}
                      color="#212121"
                    >
                      {item?.name}
                    </Typography>
                  </Stack>
                </Stack>
              ))}
            </>
          )}
        </>
      )}
    </PreviewAssigneeListCnt>
  );
}

export default PreviewAssigneeList;
